const getSelectedFlightOptionByQuery = (flightOptions, query) => ({
  preSelectedOutbound:
    query &&
    query.outboundFlightNumber &&
    flightOptions.outbound.find(
      (option) =>
        option.flightSegments?.[0].flightNumber === query.outboundFlightNumber,
    ),
  preSelectedInbound:
    query &&
    query.inboundFlightNumber &&
    flightOptions.inbound.find(
      (option) =>
        option.flightSegments?.[0].flightNumber === query.inboundFlightNumber,
    ),
});

export default getSelectedFlightOptionByQuery;
